import { useCallback, useContext } from 'react';

import { Button } from 'antd';

import { FormGroupContext } from '@/components/FormGroup';
import ProductEmail from '@/components/wizard/ProductEmail';
import ProductPaymentMethods from '@/components/wizard/ProductPaymentMethods';
import ProductPrice from '@/components/wizard/ProductPrice';
import UpgradeSales from '@/components/wizard/UpgradeSales';
import { trpc } from '@/lib/trpc';
import { validateFields } from '@/lib/validation';
import { producerDataSteps } from '@/pages/CreateProduct/steps';
import useProductStore, { productStore } from '@/stores/productStore';
import useStepStore, { stepStore } from '@/stores/steps';

import Wizard from '../..';

const Details = () => {
  const { emit } = useContext(FormGroupContext);
  const nextStep = useStepStore(({ nextStep }) => nextStep);
  const { data: myEduzzProfile, isPending } = trpc.myEduzz.getProfile.useQuery();

  const paymentType = useProductStore(d => d.payment?.type);

  const submit = useCallback(async () => {
    const results = await emit({ type: 'validate' });

    const isAllFilled =
      myEduzzProfile?.document_number &&
      myEduzzProfile?.address_zip_code &&
      myEduzzProfile?.cellphone &&
      myEduzzProfile?.fiscal_responsibility === 1 &&
      myEduzzProfile?.terms_accepted;

    if (isAllFilled) {
      nextStep({ validate: () => validateFields(results) });
      return;
    }

    productStore.getState().setFields({
      producer: {
        document: myEduzzProfile?.document_number || '',
        zipCode: myEduzzProfile?.address_zip_code || '',
        state: myEduzzProfile?.address_state || '',
        city: myEduzzProfile?.address_city_name || '',
        cityId: String(myEduzzProfile?.address_city_ibge) || '',
        streetName: myEduzzProfile?.address_street || '',
        streetNumber: myEduzzProfile?.address_number || '',
        district: myEduzzProfile?.address_neighborhood || '',
        complement: myEduzzProfile?.address_complement || '',
        native: myEduzzProfile?.type !== 'E',
        cellPhone: myEduzzProfile?.cellphone || '+55',
        fiscalTerm: myEduzzProfile?.fiscal_responsibility === 1,
        useTerm: Boolean(myEduzzProfile?.terms_accepted)
      }
    });
    stepStore.getState().addSteps({ steps: producerDataSteps });
    nextStep({ validate: () => validateFields(results) });
  }, [emit, nextStep, myEduzzProfile]);

  return (
    <div className='mt-4 mb-28 flex flex-col gap-4'>
      <ProductPrice />
      <ProductEmail />
      {paymentType !== 'free' && <ProductPaymentMethods />}
      <UpgradeSales />

      <Wizard.Footer closable preview>
        <Button type='primary' id='submit' disabled={isPending} onClick={submit}>
          Continuar
        </Button>
      </Wizard.Footer>
    </div>
  );
};
export default Details;
